var React = require('react');

function ExploreData (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t \t.st0{fill:#1478a6;}\n\t "),React.createElement("path",{"className":"st0","d":"M50,5C25.1,5,5,25.1,5,50c0,24.8,20.1,45,45,45s45-20.2,45-45C95,25.1,74.9,5,50,5L50,5z M64.2,39.9v29h-7.9\n\tv-29H64.2z M52.3,25.3v43.5h-7.9V25.3H52.3z M40.4,39.9v29h-8v-29H40.4z M24.4,76.8V25.3h4v47.5H76v4H24.4z M68.2,68.9V54.4h7.9\n\tv14.5H68.2z","key":1})]);
}

ExploreData.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 100","width":"25px","height":"25px","xmlSpace":"preserve"};

module.exports = ExploreData;

ExploreData.default = ExploreData;
